import { api } from "@breakout/backend/convex/_generated/api"
import type { Maybe } from "@breakout/shared/types/market"
import { usePaginatedQuery } from "convex/react"
import type { Address } from "viem"

interface MarketActivityArgs {
	marketAddress: Address
}

export function useMarketActivity(args: Maybe<MarketActivityArgs>) {
	const { results, status, loadMore, isLoading } = usePaginatedQuery(
		api.indexer.public.getMarketActivity,
		args ? { marketAddress: args.marketAddress } : "skip",
		{ initialNumItems: 20 },
	)

	return {
		results,
		status,
		loadMore,
		isLoading,
		hasMore: status === "CanLoadMore",
	}
}
